__turbopack_context__.v({
  "container": "BwiuYq_container",
});
